import React from "react";
import parse from "html-react-parser";

const Renderhtml = ({ data }) => {
  if (data) {
    return <div>{parse(data)}</div>;
  }
};

export default Renderhtml;
